const CONSTANT = {
  TENDENCYLIST: [ // 倾向性
    {
      TEXT: '正面',
      INDEX: 1
    },
    {
      TEXT: '中性',
      INDEX: 3
    },
    {
      TEXT: '负面',
      INDEX: 2
    }
  ],
  WARNING_LEVEL: [1, 2, 3],
  WARNING_LEVEL_INFO:{
    1: {
      TEXT: '一般',
      TYPE: 1
    },
    2: {
      TEXT: '严重',
      TYPE: 2
    },
    3: {
      TEXT: '重大',
      TYPE: 3
    }
  },
  // 复制信息常量
  COPYITEM: [{
    name: '标题',
    id: '1',
    replace: '${title}'
  },
  {
    name: '链接',
    id: '2',
    replace: '${URL}'
  },
  {
    name: '摘要',
    id: '3',
    replace: '${summary}'
  },
  {
    name: '时间',
    id: '4',
    replace: '${time}'
  },
  {
    name: '来源',
    id: '5',
    replace: '${webName}'
  },
  {
    name: '作者',
    id: '6',
    replace: '${author}'
  },
  {
    name: '倾向性',
    id: '7',
    replace: '${attitude}'
  },
  {
    name: '评论数',
    id: '8',
    replace: '${replyCount}'
  },
  {
    name: '转发数',
    id: '9',
    replace: '${forwardCount}'
  },
  {
    name: '涉及关键词',
    id: '10',
    replace: '${keyWord}'
  },
  {
    name: '认证类型',
    id: '11',
    replace: '${authorAuthType}'
  },
  {
    name: '粉丝数',
    id: '12',
    replace: '${authorFansCount}'
  },
  {
    name: '单位',
    id: '13',
    replace: '${unitName}'
  },
  {
    name: '作者ID',
    id: '14',
    replace: '${authorId}'
  },
  {
    name: '涉事省份',
    id: '15',
    replace: '${area}'
  },
  {
    name: '涉事地域',
    id: '16',
    replace: '${contentMentionRegionList}'
  },
  {
    name: '日期',
    id: '17',
    replace: '${dateDatas}'
  },
  {
    name: '抖音号',
    id: '18',
    replace: '${tikTok}'
  },
  {
    name: '快手号',
    id: '19',
    replace: '${quickHand}'
  },
  {
    name: '视频文件地址',
    id: '20',
    replace: '${videoURL}'
  },
  {
    name: '签到地',
    id: '21',
    replace: '${postPlace}'
  },
  {
    name: '阅读数',
    id: '22',
    replace: '${visitCount}'
  },
  {
    name: '点赞数',
    id: '23',
    replace: '${praiseCount}'
  },
  {
    name: '标签',
    id: '24',
    replace: '${label}'
  },
  {
    name: '专题名称',
    id: '25',
    replace: '${subjectName}'
  },
  {
    name: '专题分类名称',
    id: '26',
    replace: '${subjectClassName}'
  },
  {
    name: '信息发布地',
    id: '27',
    replace: '${ipRegion}'
  },
  {
    name: '小红书号',
    id: '28',
    replace: '${authorUserAccountNum}'
  },{
    name: '作者地域',
    id: '29',
    replace: '${authorCptLocation}'
  },
  {
    name: '文章类型',
    id: '30',
    replace: '${articleType}'
  },
  {
    name: 'AI摘要',
    id: '31',
    replace: '${aiAbstract}'
  }]
}
export default CONSTANT